import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { DashboardApi, RequestStrategyEnum, type WithSignal, type Summary } from '@shared/api';

const getSummariesEffect = createEffect(({ signal }: WithSignal = {}) => DashboardApi.getSummaries(signal));
const clearEvent = createEvent();

const $dataStore = createStore<Summary[]>([])
  .on(getSummariesEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getSummariesEffect.pending, (_, data) => data)
  .on(getSummariesEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getSummariesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getSummariesEffect, () => null)
  // .on(getSummariesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getSummariesEffect.fail, () => 'Something went wrong while fetching Currencies. Please try again.')
  .on(getSummariesEffect.done, () => null)
  .reset(clearEvent);

const getSummariesApi = ApiUtils.wrapperApi(getSummariesEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getSummariesApi.cancel());

export const $dashboardSummaryStore = {
  events: {
    getSummaries: getSummariesApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
